"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSharedDocumentFileUrlApiResponseSchema = exports.recordSharedDocumentReadingApiResponseSchema = exports.getSharedDocumentApiResponseSchema = exports.countUnreadSharedDocumentsApiResponseSchema = exports.listReceivedSharedDocumentsApiResponseSchema = exports.receivedSharedDocumentApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const shared_document_1 = require("./shared-document");
const shared_document_administration_1 = require("./shared-document-administration");
const sharedDocumentReadStatusSchema = zod_1.z.enum(shared_document_1.sharedDocumentReadStatuses);
/** Where the reader stands with a document, as every reading response carries it. */
const readerStandingSchema = zod_1.z.object({
    status: sharedDocumentReadStatusSchema,
    /** `null` while never opened. */
    firstOpenedAt: zod_1.z.coerce.date().nullable(),
    /** `null` until a mandatory read is confirmed. */
    confirmedAt: zod_1.z.coerce.date().nullable(),
});
/** A document as its reader's list shows it. */
exports.receivedSharedDocumentApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('shared-documents'),
    attributes: readerStandingSchema.extend({
        title: zod_1.z.string(),
        description: zod_1.z.string().nullable(),
        fileName: zod_1.z.string(),
        /** Size in bytes. */
        fileSize: zod_1.z.number().int(),
        mandatoryRead: zod_1.z.boolean(),
        publishedAt: zod_1.z.coerce.date(),
    }),
});
/**
 * The reader's documents, newest first — the whole list, so the counts are
 * over all of them whatever the reader searches.
 */
exports.listReceivedSharedDocumentsApiResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.receivedSharedDocumentApiResponseSchema),
    meta: zod_1.z.object({
        /** Documents never opened. */
        unreadCount: zod_1.z.number().int(),
        /** Mandatory reads opened but not confirmed yet. */
        toConfirmCount: zod_1.z.number().int(),
    }),
});
/** The menu badge: the reader's current documents never opened. */
exports.countUnreadSharedDocumentsApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({ unreadCount: zod_1.z.number().int() }),
});
/**
 * One document with the requester's standing and who it was shared with:
 * the targeted sites or offices, closed ones flagged. A people scope lists
 * nobody — who else received it is not the reader's business.
 */
exports.getSharedDocumentApiResponseSchema = zod_1.z.object({
    data: exports.receivedSharedDocumentApiResponseSchema.extend({
        attributes: exports.receivedSharedDocumentApiResponseSchema.shape.attributes.extend({
            audience: shared_document_administration_1.sharedDocumentAudienceSchema,
            scopeType: shared_document_administration_1.sharedDocumentScopeTypeSchema,
            targets: zod_1.z.array(shared_document_administration_1.sharedDocumentTargetSummarySchema),
        }),
    }),
});
/** The reader's standing once an opening or a confirmation is recorded. */
exports.recordSharedDocumentReadingApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('shared-documents'),
        attributes: readerStandingSchema,
    }),
});
/** A presigned URL of the document's file, valid five minutes. */
exports.getSharedDocumentFileUrlApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({ url: zod_1.z.string() }),
});
